<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M16.8251 3.49539H15.5149C15.6877 3.22139 15.8017 2.91383 15.8342 2.58856C15.9381 1.54903 15.3916 0.61717 14.4612 0.204029C13.606 -0.175726 12.6449 -0.0204852 11.9529 0.608295L10.2984 2.11034C9.97624 1.75731 9.51306 1.53544 8.99901 1.53544C8.48404 1.53544 8.02012 1.75802 7.69784 2.11213L6.04128 0.608119C5.34811 -0.0206613 4.38743 -0.175303 3.53261 0.20424C2.60244 0.617416 2.05584 1.5496 2.16004 2.58909C2.19263 2.91411 2.30661 3.22153 2.4794 3.49539H1.17292C0.524573 3.49539 -0.000976562 4.02189 -0.000976562 4.67135V6.4353C-0.000976562 6.76001 0.261816 7.0233 0.585991 7.0233H17.4121C17.7362 7.0233 17.999 6.76005 17.999 6.4353V4.67135C17.999 4.02189 17.4734 3.49539 16.8251 3.49539ZM7.23814 3.2994V3.49539H4.47687C3.74731 3.49539 3.17313 2.81406 3.35535 2.05314C3.43561 1.71805 3.67706 1.43239 3.98936 1.28779C4.41819 1.08923 4.89322 1.15297 5.2534 1.47955L7.23863 3.28207C7.23853 3.28788 7.23814 3.29359 7.23814 3.2994ZM14.6695 2.43244C14.6258 3.04358 14.0747 3.49546 13.4631 3.49546H10.7599V3.29947C10.7599 3.29253 10.7595 3.28566 10.7594 3.27873L12.7139 1.50406C13.0146 1.23102 13.4354 1.10356 13.8243 1.21978C14.3825 1.38657 14.7103 1.86209 14.6695 2.43244ZM1.17292 8.19926V16.8231C1.17292 17.4726 1.69847 17.999 2.34682 17.999H7.82507V8.19926H1.17292ZM10.1729 8.19926V17.999H15.6512C16.2995 17.999 16.8251 17.4726 16.8251 16.8231V8.19926H10.1729Z"
      :fill="color"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    color: {
      type: String,
      default: "white",
    },
  },
})
</script>

<style></style>
